export default __webpack_public_path__ + "static/media/loader.c86084ca.svg";